import { supabase } from '../lib/supabase';

export const walletService = {
  /**
   * Fetches the current balance for the authenticated user.
   */
  async getBalance() {
    const { data: { user }, error: authError } = await supabase.auth.getUser();
    if (authError || !user) throw new Error('User not authenticated');

    const { data, error } = await supabase
      .from('user_wallets')
      .select('balance')
      .eq('user_id', user.id)
      .maybeSingle();

    if (error) throw error;
    return data?.balance || 0;
  },

  /**
   * Fetches the transaction history for the authenticated user.
   */
  async getTransactions() {
    const { data: { user }, error: authError } = await supabase.auth.getUser();
    if (authError || !user) throw new Error('User not authenticated');

    const { data, error } = await supabase
      .from('store_credit_transactions')
      .select('*')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  }
};
